/**
 * Safely finds the last user message from a chat messages array without mutating the original array.
 * This utility prevents the common bug where Array.reverse() mutates the original array.
 *
 * @param chatMessages - Array of chat messages
 * @returns The last user message object, or undefined if no user message is found
 * @public
 */
export const getLastUserMessage = chatMessages => {
  if (!chatMessages || chatMessages.length === 0) {
    return undefined;
  }
  // Iterate backwards through the array to find the last user message
  for (let i = chatMessages.length - 1; i >= 0; i--) {
    if (chatMessages[i].role === 'user') {
      return chatMessages[i];
    }
  }
  return undefined;
};
/**
 * Safely gets the content of the last user message from a chat messages array.
 *
 * @param chatMessages - Array of chat messages
 * @returns The content of the last user message, or undefined if no user message is found
 * @public
 */
export const getLastUserMessageContent = chatMessages => {
  const lastUserMessage = getLastUserMessage(chatMessages);
  return (lastUserMessage === null || lastUserMessage === void 0 ? void 0 : lastUserMessage.content) || undefined;
};